import React from 'react';
import { ImageQualityGate } from '../imageQuality/ImageQualityGate';
import AssociateScorecards from './AssociateScorecards';

/**
 * The Associate Scorecards page (route /associate-scorecards), behind the same image-quality gate as
 * Evidence Image Quality: the two pages launch together, and a scorecard opens the associate there.
 */
const AssociateScorecardsGated: React.FC = () => (
  <ImageQualityGate pageName="Associate Scorecards" testIdPrefix="associate-scorecards">
    <AssociateScorecards />
  </ImageQualityGate>
);

export default AssociateScorecardsGated;
